import { createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2fc519c4")

_pushScopeId("data-v-2fc519c4")
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "r-grid container" }, [
  /*#__PURE__*/_createVNode("h2", null, "Detailed Leave Balance")
], -1)
const _hoisted_3 = { class: "description" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" All these balances are based on time off reported for the current benefit year. For more information about your leave benefits, accruals, and limits visit the ")
const _hoisted_5 = /*#__PURE__*/_createVNode("a", { href: "https://www.hr.uillinois.edu/leave/" }, "HR Leaves Resource page", -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Sick and Personal day balances are based on time off reported for the current semester. For more information on eligibility, please see the GEO collective bargaining agreement: ")
const _hoisted_8 = /*#__PURE__*/_createVNode("a", { href: "https://uofi.app.box.com/s/ss7k0rr8ndw1qrz20fbbvokfwjxk4x3m" }, "GEO CBA", -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_10 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("span", { class: "asterisk" }, "* ", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("span", { class: "asterisk" }, "** ", -1)
const _hoisted_14 = { class: "r-grid grid-container" }
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "header" }, "Leave Type", -1)
const _hoisted_16 = { class: "header" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "expanded-item grid-container" }
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { class: "header" }, "Description", -1)
const _hoisted_20 = { class: "header" }
const _hoisted_21 = /*#__PURE__*/_createVNode("div", null, "Leave Code", -1)
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { key: 2 }
const _hoisted_25 = { key: 3 }
const _hoisted_26 = { key: 4 }
const _hoisted_27 = { key: 5 }
const _hoisted_28 = { key: 6 }
const _hoisted_29 = { key: 7 }
const _hoisted_30 = {
  key: 0,
  class: "expanded-item grid-container projected"
}
const _hoisted_31 = { key: 0 }
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" Projected Accrued ")
const _hoisted_33 = /*#__PURE__*/_createVNode("span", { class: "asterisk" }, "*", -1)
const _hoisted_34 = { key: 1 }
const _hoisted_35 = { key: 2 }
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" Projected Balance")
const _hoisted_37 = /*#__PURE__*/_createVNode("span", { class: "asterisk" }, " *", -1)
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { key: 3 }
const _hoisted_40 = { key: 0 }
const _hoisted_41 = {
  key: 0,
  class: "asterisk"
}
const _hoisted_42 = { key: 4 }
const _hoisted_43 = /*#__PURE__*/_createTextVNode(" Projected Loss ")
const _hoisted_44 = /*#__PURE__*/_createVNode("span", { class: "asterisk" }, "*", -1)
const _hoisted_45 = { key: 5 }
const _hoisted_46 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createTextVNode("Projected Through Date "),
  /*#__PURE__*/_createVNode("span", { class: "asterisk" }, "*")
], -1)
const _hoisted_47 = {
  key: 1,
  class: "expanded-item grid-container"
}
const _hoisted_48 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createTextVNode(" Through Date "),
  /*#__PURE__*/_createVNode("span", { class: "asterisk" })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_arrowSVG = _resolveComponent("arrowSVG")!

  return (_ctx.userInfoData)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _hoisted_2,
        _createVNode("div", _hoisted_3, [
          (_ctx.userInfoData.leaves_value_type === 'Hours')
            ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                _hoisted_4,
                _hoisted_5,
                _hoisted_6
              ], 64))
            : (_ctx.userInfoData.leaves_value_type === 'Days')
              ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                  _hoisted_7,
                  _hoisted_8,
                  _hoisted_9
                ], 64))
              : _createCommentVNode("", true),
          (_ctx.projectedExists)
            ? (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
                _hoisted_10,
                _hoisted_11,
                _createTextVNode(" Projected Accruals shown includes the number of " + _toDisplayString(_ctx.lowercase) + " accrued up till today. The Projected Accrual and Projected Balance values are an estimate of accumulated " + _toDisplayString(_ctx.lowercase) + " by the end of the benefit period (Projected Through Date). ", 1)
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.balanceOverLimit)
            ? (_openBlock(), _createBlock(_Fragment, { key: 3 }, [
                _hoisted_12,
                _hoisted_13,
                _createTextVNode(" You are expected to lose a portion of your vacation " + _toDisplayString(_ctx.lowercase) + " by the end of the benefit year if not used. Please refer to your employment benefit limits and accruals for more information. ", 1)
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_14, [
          _hoisted_15,
          _createVNode("div", _hoisted_16, "Balance (" + _toDisplayString(_ctx.userInfoData.leaves_value_type) + ")", 1)
        ]),
        (_ctx.userInfoData)
          ? (_openBlock(), _createBlock("ol", _hoisted_17, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.userInfoData.leaveBalance, (item, index) => {
                return (_openBlock(), _createBlock("li", {
                  class: ["r-grid grid-container leave-type-item", { 'expanded': item.boolean }],
                  key: index,
                  "aria-expanded": item.boolean
                }, [
                  _createVNode("div", {
                    onClick: ($event: any) => (item.boolean = !item.boolean)
                  }, _toDisplayString(item.name), 9, ["onClick"]),
                  _createVNode("div", {
                    onClick: ($event: any) => (item.boolean = !item.boolean)
                  }, _toDisplayString(item.balance), 9, ["onClick"]),
                  _createVNode("button", {
                    onClick: ($event: any) => (item.boolean = !item.boolean),
                    class: [{ 'active': item.boolean }, "toggle-button"]
                  }, [
                    _createVNode(_component_arrowSVG)
                  ], 10, ["onClick"]),
                  _withDirectives(_createVNode("div", _hoisted_18, [
                    _hoisted_19,
                    _createVNode("div", _hoisted_20, "Value (" + _toDisplayString(_ctx.userInfoData.leaves_value_type) + ")", 1),
                    _hoisted_21,
                    _createVNode("div", null, _toDisplayString(item.code), 1),
                    (item.beginning || item.beginning === 0)
                      ? (_openBlock(), _createBlock("div", _hoisted_22, "Beginning Balance"))
                      : _createCommentVNode("", true),
                    (item.beginning || item.beginning === 0)
                      ? (_openBlock(), _createBlock("div", _hoisted_23, _toDisplayString(item.beginning), 1))
                      : _createCommentVNode("", true),
                    (item.accrued || item.accrued === 0)
                      ? (_openBlock(), _createBlock("div", _hoisted_24, "Accrued"))
                      : _createCommentVNode("", true),
                    (item.accrued || item.accrued === 0)
                      ? (_openBlock(), _createBlock("div", _hoisted_25, _toDisplayString(item.accrued), 1))
                      : _createCommentVNode("", true),
                    (item.taken || item.taken === 0)
                      ? (_openBlock(), _createBlock("div", _hoisted_26, "Taken"))
                      : _createCommentVNode("", true),
                    (item.taken || item.taken === 0)
                      ? (_openBlock(), _createBlock("div", _hoisted_27, _toDisplayString(item.taken), 1))
                      : _createCommentVNode("", true),
                    (item.balance || item.balance === 0)
                      ? (_openBlock(), _createBlock("div", _hoisted_28, "Balance"))
                      : _createCommentVNode("", true),
                    (item.balance || item.balance === 0)
                      ? (_openBlock(), _createBlock("div", _hoisted_29, _toDisplayString(item.balance), 1))
                      : _createCommentVNode("", true)
                  ], 512), [
                    [_vShow, item.boolean]
                  ]),
                  (
          item.boolean
          && item.projection_eligible === true
        )
                    ? (_openBlock(), _createBlock("div", _hoisted_30, [
                        (item.projected_accrued || item.projected_accrued === 0)
                          ? (_openBlock(), _createBlock("div", _hoisted_31, [
                              _hoisted_32,
                              _hoisted_33
                            ]))
                          : _createCommentVNode("", true),
                        (item.projected_accrued || item.projected_accrued === 0)
                          ? (_openBlock(), _createBlock("div", _hoisted_34, _toDisplayString(item.projected_accrued), 1))
                          : _createCommentVNode("", true),
                        (item.projected_balance || item.projected_balance === 0)
                          ? (_openBlock(), _createBlock("div", _hoisted_35, [
                              _hoisted_36,
                              _hoisted_37,
                              (item.projected_balance_nolimit)
                                ? (_openBlock(), _createBlock("span", _hoisted_38, " (Without Limit)"))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        (item.projected_balance || item.projected_balance === 0)
                          ? (_openBlock(), _createBlock("div", _hoisted_39, [
                              _createTextVNode(_toDisplayString(item.projected_balance) + " ", 1),
                              (item.projected_balance_nolimit)
                                ? (_openBlock(), _createBlock("span", _hoisted_40, [
                                    _createTextVNode(" (" + _toDisplayString(item.projected_balance_nolimit) + ") ", 1),
                                    (item.projectedOverVacaHourCap)
                                      ? (_openBlock(), _createBlock("span", _hoisted_41, " **"))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        (item.projected_loss || item.projected_loss === 0)
                          ? (_openBlock(), _createBlock("div", _hoisted_42, [
                              _hoisted_43,
                              _hoisted_44
                            ]))
                          : _createCommentVNode("", true),
                        (item.projected_loss || item.projected_loss === 0)
                          ? (_openBlock(), _createBlock("div", _hoisted_45, _toDisplayString(item.projected_loss), 1))
                          : _createCommentVNode("", true),
                        _hoisted_46,
                        _createVNode("div", null, _toDisplayString(_ctx.parseDate(item.thru_date)), 1)
                      ]))
                    : (item.boolean
        && item.thru_date
        && !item.projected_accrued
        && !item.projected_balance)
                      ? _withDirectives((_openBlock(), _createBlock("div", _hoisted_47, [
                          _hoisted_48,
                          _createVNode("div", null, _toDisplayString(_ctx.parseDate(item.thru_date)), 1)
                        ], 512)), [
                          [_vShow, item.boolean]
                        ])
                      : _createCommentVNode("", true)
                ], 10, ["aria-expanded"]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
})